import React from 'react'
import { makeStyles } from "@material-ui/core/styles"
import Paper from '@material-ui/core/Paper'

const useStyles = makeStyles((theme) => ({
    desktopWindow: {
        borderRadius: "6px",
        overflow: "hidden",
        border: "1px solid rgba(0,0,0,0.2)",
        [theme.breakpoints.only('xs')]: {
            margin: `-8rem 4px 0px 4px`,
        },
        position: "relative",
        marginTop: '-6rem'
    },
    desktopWindowHeader: {
        backgroundColor: "#e0e0e0",
        height: "24px",
        width: "100%"
    },
    desktopWindowBody: {
        backgroundColor: "#2e3440",
        color: "#eceff4",
        fontFamily: "'Fira Code', monospace",
        fontSize: "16px",
        lineHeight: "24px",
        padding: "0 1em",
        width: "100%"
    },
    desktopWindowHeaderButtons: {
        float: "left"
    },
    desktopWindowHeaderTitle: {
        color: "#4d494d",
        cursor: "default",
        fontSize: "12px",
        fontWeight: "normal",
        lineHeight: "24px",
        margin: 0,
        textAlign: "center",
        userSelect: "none"
    }

}));

const DesktopWindow = ({title, children}) => {
    const classes = useStyles()

    return (
        <Paper className={classes.desktopWindow}>
            <div className={classes.desktopWindowHeader}>
                <svg
                    className={classes.desktopWindowHeaderButtons}
                    viewBox="0 0 80 24"
                    xmlns="http://www.w3.org/2000/svg"
                    width="80"
                    height="24">
                    <circle cx="16" cy="12" r="6" fill="#ff5c5c" stroke="#e33e41" strokeWidth="1"/>
                    <circle cx="40" cy="12" r="6" fill="#ffbd4c" stroke="#e09e3e" strokeWidth="1"/>
                    <circle cx="64" cy="12" r="6" fill="#00ca56" stroke="#14ae46" strokeWidth="1"/>
                </svg>
                <h1 className={classes.desktopWindowHeaderTitle}>{title}</h1>
            </div>
            <div className={classes.desktopWindowBody}>{children}</div>
        </Paper>
    )


}

export default DesktopWindow
